<template>
    <div class="layout">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath">
                <!-- 这里是会被缓存的视图组件，比如 Home！ -->
            </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
        <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
    </div>
</template>
<script>
    import router from '../.././router'
    import {
        LOGOUT,
        LOGIN
    } from '../.././vuex/mutation_types'
    export default {
        data() {
            return {
                isCollapsed: false, // 侧栏开关
                menuData: [], // 左侧菜单
                breadCrumbList: [], // 面包屑
                title: '首页', // 标题
                btns: [], // 功能按钮组
                active: 'home',
            };
        },
        computed: {
        },
        // watch:{
        //     $route(val){
        //         this.pageChange(val.name);
        //     }
        // },
        created: function () {
            // console.log(this.$route)
            if ( this.$route.name != this.active ) {
                // this.pageChange(this.$route.name);
                this.active = this.$route.name;
            }
        },
        methods: {
            pageChange(event) {
                this.$router.push(`/${event}/index`);
                this.active = event;
            }
        },
    }
</script>